import "./index.less"
import "./indexMobile.less"
import {Col, Row} from "antd";
import Carousel from "./Carousel";
import MoreButton from "../../MoreButton";
import Slider from "react-slick";
import Card from "./Card";
import React, {useEffect, useState} from "react";
import {isMobile} from "react-device-detect";

export default () => {

    function SampleNextArrow(props) {
        const {className, style, onClick} = props;
        return (
            <div className={className} style={{...style, position: "absolute", right: "60px", top: "40%", zIndex: 20}}
                 onClick={onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle opacity="0.45" cx="32" cy="32" r="32" fill="black"/>
                    <path d="M14 32H49.5C46 32.3333 39 34.9 39 42.5" stroke="white" stroke-width="2"/>
                </svg>
            </div>
        );
    }

    function SamplePrevArrow(props) {
        const {className, style, onClick} = props;
        return (
            <div className={className} style={{...style, position: "absolute", left: "20px", top: "40%", zIndex: "20"}}
                 onClick={onClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle opacity="0.45" cx="32" cy="32" r="32" fill="black"/>
                    <path d="M49.5 32H14C17.5 32.3333 24.5 34.9 24.5 42.5" stroke="white" stroke-width="2"/>
                </svg>
            </div>
        );
    }

    const [settingsData, setSettingsData] = useState({
        dots: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow/>,
        prevArrow: <SamplePrevArrow/>
    })

    // 获得视口分辨率
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        // 监听视口分辨率
        window.addEventListener('resize', () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        });

        return () => {
            window.removeEventListener('resize', () => {
                setWidth(window.innerWidth);
                setHeight(window.innerHeight);
            });
        }
    })

    useEffect(() => {
        console.log("数据 -> ", width, height)

        if (width >= 1600) {
            setSettingsData({
                dots: true,
                infinite: true,
                speed: 500,
                centerMode: true,
                centerPadding: '280px',
                slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                nextArrow: <SampleNextArrow/>,
                prevArrow: <SamplePrevArrow/>
            })
        } else {
            setSettingsData({
                dots: true,
                infinite: true,
                speed: 500,
                centerMode: true,
                centerPadding: isMobile ? '-20px' : '90px',
                slidesToShow: isMobile ? 1 : 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                nextArrow: isMobile ? null : <SampleNextArrow/>,
                prevArrow: isMobile ? null : <SamplePrevArrow/>
            })
        }
    }, [width, height])


    const cardItems = [{
        date: "2014-12-20",
        title: "SOURCE年度盛典：时尚与艺术的完美融合",
        desc: "SOURCE年度盛典将在新乐路158号店铺举行，当晚将有各界名人出席，一同庆祝过去一年的成就。",
        imageUrl: "/eventCardCovers/img_1.png"
    }, {
        date: "2014-10-15",
        title: "源自创意：SOURCE与当代艺术家的对话",
        desc: "本次展览将展示10位当代艺术家的创新作品，意在推广与艺术和创意有关的主题。",
        imageUrl: "/eventCardCovers/img_4.jpg"
    }, {
        date: "2014-07-09",
        title: "Summer Chill：SOURCE夏日特辑",
        desc: "在炎热的夏天，SOURCE特别推出夏日特辑，包括清凉饮品和限量版T恤。",
        imageUrl: "/eventCardCovers/img.png"
    }, {
        date: "2013-11-05",
        title: "音乐无界：SOURCE音乐节",
        desc: "一场为期两天的音乐节，汇聚各种音乐风格，打破音乐的界限。",
        imageUrl: "/eventCardCovers/img_2.png"
    }, {
        date: "2013-04-22",
        title: "Earth Day：源于责任",
        desc: "为了庆祝地球日，SOURCE组织了一系列环保活动和讲座，旨在提高环境保护意识。",
        imageUrl: "/eventCardCovers/img_3.png"
    }, {
        date: "2012-12-15",
        title: "冬季时尚展",
        desc: "展示冬季最新时尚潮流和产品，吸引时尚界人士共同参与。",
        imageUrl: "/eventCardCovers/img_10.jpg"
    }, {
        date: "2012-09-01",
        title: "回归本源：SOURCE纪念品发布会",
        desc: "SOURCE发布了一系列具有品牌标志性的纪念品，包括T恤、帽子和滑板。",
        imageUrl: "/eventCardCovers/img_8.jpg"
    }, {
        date: "2011-05-13",
        title: "源于街头：街头艺术展览",
        desc: "SOURCE邀请了多位街头艺术家现场创作，展示了街头文化的多元性和活力。",
        imageUrl: "/eventCardCovers/img_7.jpg"
    }, {
        date: "2010-08-22",
        title: "SOURCE周年庆典",
        desc: "庆祝SOURCE成立多年，特别策划了一系列活动和特别优惠，以答谢长久以来的支持。",
        imageUrl: "/eventCardCovers/img_9.jpg"
    }, {
        date: "2009-11-19",
        title: "SOURCE首届摄影比赛",
        desc: "邀请摄影爱好者参与，展示他们对城市、文化和人的独特视角。",
        imageUrl: "/eventCardCovers/img_6.jpeg"
    }];

    return <>
        {!isMobile && <div className={"section latestEventstest"}>
            <div className={"topBg"}/>
            <div className={"topBg2"}/>
            <div className={"triangle"}></div>
            <div className={"leftLightning"}>
                <svg width="800" height="482" viewBox="0 0 588 482" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M190.798 415.977L-212 276.769L-212 -3.05176e-05L33.4677 257.823L33.4677 131.795L587.829 481.874L147.141 305.599L190.798 415.977Z"
                        fill="black" fill-opacity="0.02"/>
                </svg>
            </div>

            <div className={"rightLightning"}>
                <svg width="800" height="483" viewBox="0 0 800 483" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M397.202 416.533L800 277.325V0.556244L554.532 258.38V132.351L0.170837 482.431L440.859 306.155L397.202 416.533Z"
                        fill="black" fill-opacity="0.02"/>
                </svg>
            </div>

            <div className={"latestEvents-Title"}>
                <Row justify={"center"}>
                    <Col>
                        <div className={"titleTag"}>
                            Latest Events
                        </div>
                    </Col>
                </Row>

                <Row justify={"center"}>
                    <div className={"titleText"}>
                        历史活动
                    </div>
                </Row>

                <Row style={{marginTop: "0px"}}>
                    {/*<Carousel items={cardItems} styleData={{width: "350px", height: "453px"}}*/}
                    {/*          contentStyle={{marginTop: "-90px"}}/>*/}

                    <Slider {...settingsData} className={"latestEvents-Slider"} style={{width: "100vw"}}>
                        {cardItems.map((item, index) => (
                            <Card key={index}
                                  {...item}
                                  hasDragged={false}
                                  styleData={{width: "350px", height: "453px"}}
                                  contentStyle={{marginTop: "-90px"}}
                            />
                        ))}
                    </Slider>
                </Row>

                <Row justify={"center"} style={{marginTop: "40px", marginLeft: "-105px"}}>
                    <Col>
                        <MoreButton url={"/brandInformation"}/>
                    </Col>
                </Row>
            </div>
        </div>}

        {isMobile && <div className={"section"}>
            <div className={"topBg-mobile"}/>
            <div className={"topBg2-mobile"}/>
            <div className={"triangle-mobile"}></div>
            <div className={"leftLightning-mobile"}>
                <svg width="800" height="482" viewBox="0 0 588 482" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M190.798 415.977L-212 276.769L-212 -3.05176e-05L33.4677 257.823L33.4677 131.795L587.829 481.874L147.141 305.599L190.798 415.977Z"
                        fill="black" fill-opacity="0.02"/>
                </svg>
            </div>

            <div className={"rightLightning-mobile"}>
                <svg width="800" height="483" viewBox="0 0 800 483" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M397.202 416.533L800 277.325V0.556244L554.532 258.38V132.351L0.170837 482.431L440.859 306.155L397.202 416.533Z"
                        fill="black" fill-opacity="0.02"/>
                </svg>
            </div>

            <div className={"latestEvents-Title-mobile"}>
                <Row justify={"center"}>
                    <Col>
                        <div className={"titleTag-mobile"}>
                            Latest Events
                        </div>
                    </Col>
                </Row>

                <Row justify={"center"}>
                    <div className={"titleText-mobile"}>
                        历史活动
                    </div>
                </Row>

                <Row style={{marginTop: "0px"}}>
                    {/*<Carousel items={cardItems} styleData={{width: "350px", height: "453px"}}*/}
                    {/*          contentStyle={{marginTop: "-90px"}}/>*/}

                    <Slider {...settingsData} className={"latestEvents-Slider-mobile"} style={{width: "100vw"}}>
                        {cardItems.map((item, index) => (
                            <Card key={index}
                                  {...item}
                                  hasDragged={false}
                                  contentStyle={{marginTop: "-90px"}}
                                  dateStyle={{
                                      marginTop: "50px"
                                  }}
                                  titleStyle={{
                                      marginTop: "30px"
                                  }}
                            />
                        ))}
                    </Slider>
                </Row>

                <Row justify={"center"} style={{marginTop: "40px", marginLeft: "-105px"}}>
                    <Col>
                        <MoreButton url={"/brandInformation"}/>
                    </Col>
                </Row>
            </div>
        </div>}
    </>
}